import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const EditcompetitionApi = createAsyncThunk(
  "auth/Editcompetition",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.patch(apiRoutes.competitionAction(`${data.id}`, 1), data)
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const EditcompetitionSlice = createSlice({
  name: "Edit competition",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(EditcompetitionApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(EditcompetitionApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(EditcompetitionApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const Editcompetitionreducer = EditcompetitionSlice.reducer;
